import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IntubationService } from '../../intubation/services/intubation.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setStyletUsedOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getStyletUsedOptions])
    const { entity } = response
    yield put(actions.setStyletUsedOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setStyletUsedOptions() error: ${e}`))
  }
}
export function* setStyletUsedOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setStyletUsedOptions)
}
